import { jsx as c } from "@emotion/react/jsx-runtime";
import a, { useMemo as R, useState as p, useRef as E, useEffect as f } from "react";
import i from "prop-types";
import { COLORS as t } from "./constants.mjs";
const o = {
  LIGHT: "light",
  DARK: "dark"
}, H = {
  [o.LIGHT]: {
    text: t.BLACK,
    background: t.WHITE,
    foreground: t.BLACK,
    foregroundHighlight: t.WHITE,
    contrast: t.BLACK,
    transparent0: t.TRANSPARENT_BLACK_0,
    transparent1: t.TRANSPARENT_BLACK_1,
    transparent2: t.TRANSPARENT_BLACK_2,
    buttonHover: t.GRAY_3,
    buttonContrastHover: t.GRAY_1
  },
  [o.DARK]: {
    text: t.WHITE,
    background: t.BLACK,
    foreground: t.WHITE,
    foregroundHighlight: t.BLACK,
    contrast: t.WHITE,
    transparent0: t.TRANSPARENT_WHITE_0,
    transparent1: t.TRANSPARENT_WHITE_1,
    transparent2: t.TRANSPARENT_WHITE_2,
    buttonHover: t.GRAY_1,
    buttonContrastHover: t.GRAY_3
  }
}, u = (e) => {
  const r = typeof e == "string" && Object.values(o).includes(e) ? e : o.DARK;
  return {
    theme: r,
    colors: H[r]
  };
}, T = a.createContext(u(o.DARK));
function m() {
  return a.useContext(T);
}
function L(e) {
  return (...r) => {
    const n = m();
    return R(() => typeof e == "function" ? e(n, ...r) : e, [n, r]);
  };
}
const C = ({ theme: e, ...r }) => {
  const [n, A] = p(u(e)), s = E(e);
  return f(() => {
    s.current !== e && (A(u(e)), s.current = e);
  }, [e]), /* @__PURE__ */ c(T.Provider, { value: n, ...r });
};
C.propTypes = {
  theme: i.oneOf(Object.values(o))
};
const N = T.Consumer;
export {
  o as THEMES,
  N as ThemeConsumer,
  C as ThemeProvider,
  L as makeStyles,
  m as useTheme
};
